import { useIsMobile } from "../hooks";
import { Box, Divider, Flex, HStack, Text } from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";
import { Message, User } from "../apis";
import { APPC, UTIL } from "../config";

interface AppMessageProps {
    data: Message;
    loggedInUserId: number;
    onDownload: (message: Message) => void;
}

export const AppMessage = ({
    data,
    loggedInUserId,
    onDownload,
}: AppMessageProps) => {
    const isMobile = useIsMobile();
    const dayjs = UTIL.getDayJs();
    const isMe = (data?.user as User)?.meta?.id === loggedInUserId;
    const isFile = !!data?.attachmentName;
    const boxStyle = isMe
        ? {
              right: "-10px",
              borderTop: "10px solid var(--chakra-colors-primaryT80)",
              borderRight: "10px solid transparent",
              borderTopRightRadius: "4px",
          }
        : {
              left: "-10px",
              borderTop: `10px solid ${UTIL.getRandomColors(
                  (data.user as User)?.meta?.id || 0
              )}`,
              borderLeft: "10px solid transparent",
              borderTopLeftRadius: "4px",
          };
    // const actionOptions: AppOptionBoxItem[] = [
    //     {
    //         key: "delete",
    //         label: t("cmn:option.delete"),
    //         iconName: "icl-trash",
    //     },
    // ];

    return (
        <HStack
            flexDir={isMe ? "row-reverse" : "row"}
            // _hover={{
            //     ".options-icon": {
            //         visibility: "visible",
            //     },
            // }}
        >
            <Box
                bg={
                    isMe
                        ? "var(--chakra-colors-primaryT80)"
                        : UTIL.getRandomColors(
                              (data.user as User)?.meta?.id || 0
                          )
                }
                px={3}
                py={1.5}
                borderRadius={"0.25rem"}
                borderTopRightRadius={isMe ? 0 : "0.25rem"}
                borderTopLeftRadius={isMe ? "0.25rem" : 0}
                textStyle={"regularSm"}
                position={"relative"}
                maxW={"90%"}
            >
                {!isMe && (
                    <Text
                        pb={1.5}
                        lineHeight={1}
                        textStyle={"mediumXs"}
                        color={"var(--chakra-colors-primary)"}
                        whiteSpace="nowrap"
                        maxW="max-content"
                    >
                        {(data.user as User)?.meta?.fullName}
                    </Text>
                )}
                {isFile && (
                    <Flex
                        py={3}
                        gap={3}
                        borderRadius={"0.25rem"}
                        alignItems={"center"}
                    >
                        <Box minW={"30px"}>
                            <AppIcon
                                name="icl-paperclip"
                                w="2.25rem"
                                color="var(--chakra-colors-greyT40)"
                            />
                        </Box>
                        <Flex flexDir={"column"} gap={2} overflow={"hidden"}>
                            <Text
                                textStyle={"mediumSm"}
                                lineHeight={1.25}
                                noOfLines={2}
                            >
                                {data?.attachmentName}
                            </Text>
                            <Text
                                textStyle={"mediumXs"}
                                lineHeight={1}
                                color={"var(--chakra-colors-contentT60)"}
                            >
                                {UTIL.formatFileSize(data?.attachmentSize || 0)}
                            </Text>
                        </Flex>
                        <Box
                            ml={3}
                            cursor={"pointer"}
                            alignSelf={"flex-start"}
                            onClick={() => onDownload(data)}
                        >
                            <AppIcon
                                name="icl-cloud-download"
                                w="2.25rem"
                                color="var(--chakra-colors-greyT40)"
                            />
                        </Box>
                    </Flex>
                )}
                {isFile && data.message && (
                    <Divider
                        mb={3}
                        borderColor={
                            isMe
                                ? "var(--chakra-colors-primaryT50)"
                                : "var(--chakra-colors-primaryT70)"
                        }
                    />
                )}
                {data.message && (
                    <Text
                        whiteSpace={"pre-wrap"}
                        textStyle={isMobile ? "regularXs" : "regularSm"}
                        dangerouslySetInnerHTML={{
                            __html: UTIL.parseLinks(data.message),
                        }}
                    />
                )}
                <Box position={"absolute"} top={0} {...boxStyle}></Box>
            </Box>
            <Text
                as={"span"}
                alignSelf={"flex-end"}
                textStyle={"regularXs"}
                color={
                    isMe
                        ? "var(--chakra-colors-primaryT40)"
                        : "var(--chakra-colors-primaryT30)"
                }
            >
                {`${dayjs(data.createdAt).format(APPC.APP_DP_TIME_FORMAT)}`}
            </Text>
            {/* <Box visibility="hidden" className="options-icon">
                <AppOptionsBox
                    options={actionOptions}
                    iconSize="0.90rem"
                    onClick={() => {}}
                />
            </Box> */}
        </HStack>
    );
};

// import emoji from "emoji-dictionary";

// function replaceEmojis(text) {
//   return text.replace(/:([a-zA-Z0-9_+-]+):/g, (match, code) => {
//     const em = emoji.getUnicode(code);
//     return em ? em : match;
//   });
// }

//////////////////////////////

// import React from "react";

// // Simple regex patterns
// const URL_REGEX = /(https?:\/\/[^\s]+)/g;
// const MENTION_REGEX = /@(\w+)/g;
// const BOLD_REGEX = /\*\*(.*?)\*\*/g;
// const ITALIC_REGEX = /\*(.*?)\*/g;

// function parseMessage(text) {
//   // Split text by newline first
//   const lines = text.split("\n");

//   return lines.map((line, lineIndex) => {
//     // Replace URLs with <a>
//     const urlParsed = line.split(URL_REGEX).map((part, i) => {
//       if (URL_REGEX.test(part)) {
//         return (
//           <a
//             key={`url-${i}`}
//             href={part}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ color: "#1a0dab" }}
//           >
//             {part}
//           </a>
//         );
//       }
//       return part;
//     });

//     // Replace mentions with styled span
//     const mentionParsed = urlParsed.map((part, j) => {
//       if (typeof part === "string") {
//         return part.split(MENTION_REGEX).map((p, k) => {
//           if (k % 2 === 1) {
//             return (
//               <span key={`mention-${j}-${k}`} style={{ color: "#ff4500", fontWeight: "bold" }}>
//                 @{p}
//               </span>
//             );
//           }
//           return p;
//         });
//       }
//       return part;
//     }).flat();

//     // Replace **bold** and *italic*
//     const formattingParsed = mentionParsed.map((part, idx) => {
//       if (typeof part === "string") {
//         // Bold
//         let boldSplit = part.split(BOLD_REGEX).flatMap((p, i) => (i % 2 === 1 ? <b key={`b-${idx}-${i}`}>{p}</b> : p));
//         // Italic
//         return boldSplit.flatMap((p, i) =>
//           typeof p === "string"
//             ? p.split(ITALIC_REGEX).flatMap((t, j) => (j % 2 === 1 ? <i key={`i-${idx}-${i}-${j}`}>{t}</i> : t))
//             : p
//         );
//       }
//       return part;
//     }).flat();

//     return (
//       <span key={lineIndex}>
//         {formattingParsed}
//         {lineIndex < lines.length - 1 && <br />}
//       </span>
//     );
//   });
// }

// export default function ChatMessage({ message }) {
//   return (
//     <div style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}>
//       {parseMessage(message)}
//     </div>
//   );
// }
